export default "__VITE_ASSET__156117fa__"